import { styled } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';

export const StyledDrawer = styled(Drawer)({
  '& .MuiDrawer-paper': {
    '&::-webkit-scrollbar-track': {
      WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3)',
      borderRadius: 10,
      backgroundColor: '#F5F5F5'
    },
    '&::-webkit-scrollbar': {
      width: 8,
      backgroundColor: '#F5F5F5'
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: 10,
      WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,.3)',
      backgroundColor: '#a0a0a0'
    }
  }
});
